import { configureStore } from '@reduxjs/toolkit';
import type { IModuleState } from '@platform/core/types';
import { devSession } from '@platform/dao';
import { baseApi } from '@platform/state/api/baseApi';
import { registeredModuleSlices } from './modules/moduleSliceRegistry';
import { persistence } from './persistence';
import { rootReducer } from './rootReducer';
import { sessionHydrated } from './slices/sessionSlice';
import { viewStateHydrated } from './slices/viewStateSlice';

/** Store застосунку: кореневий reducer платформи з лінивими зрізами пакетів модулів (06-Frontend/state.md). */
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefault) => getDefault().concat(baseApi.middleware),
});

/**
 * Гідратує сесію (простір — з sessionStorage вкладки, інакше останній використаний) та viewState з localStorage і підписує збереження: сесія (разом із мовою заголовка Accept-Language — devSession.lang),
 * viewState і стан кожного зареєстрованого зрізу пакета модуля (окремий ключ на модуль; гідратується сам зріз при створенні).
 */
export function hydrateStore(): void {
  const session = persistence.loadSession();
  if (session) store.dispatch(sessionHydrated(session));
  persistence.saveSession(store.getState().session);   // нова вкладка одразу закріплює взятий простір за собою (ADR-028)
  const viewState = persistence.loadViewState();
  if (viewState) store.dispatch(viewStateHydrated(viewState));
  let lastSession = store.getState().session;
  let lastViewState = store.getState().viewState;
  const lastModules = new Map<string, IModuleState>();
  devSession.lang = lastSession.lang;
  store.subscribe(() => {
    const s = store.getState();
    if (s.session !== lastSession) {
      lastSession = s.session;
      persistence.saveSession(s.session);
      devSession.lang = s.session.lang;
    }
    if (s.viewState !== lastViewState) { lastViewState = s.viewState; persistence.saveViewState(s.viewState); }
    for (const [moduleKey, slice] of registeredModuleSlices()) {
      const current = slice.selectState(s);
      if (current !== lastModules.get(moduleKey)) { lastModules.set(moduleKey, current); persistence.saveModuleState(moduleKey, current); }
    }
  });
}
